// @flow

import * as colors from '../colors'

export const global = {
  primary: colors.yellow,
  accent: colors.darkPurple,
  borderColor: colors.dawnPink,
  background: colors.almostWhite,
  backgroundDesktop: colors.beige,
}

export const hire: typeof global = {
  primary: colors.orange,
  accent: colors.white,
  borderColor: colors.dawnPink,
  background: colors.almostWhite,
  backgroundDesktop: colors.almostWhite,
}

export const plan: typeof global = {
  primary: colors.violet,
  accent: colors.white,
  borderColor: colors.almond,
  background: colors.beige,
  backgroundDesktop: colors.beige,
}

export const track: typeof global = {
  primary: colors.pink,
  accent: colors.white,
  borderColor: colors.almond,
  background: colors.beige,
  backgroundDesktop: colors.beige,
}
